// extracted by mini-css-extract-plugin
export default {"body":"MainLayout_body__zG0gr","marginHeader":"MainLayout_marginHeader__UtVWi"};